// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useContext } from 'react';
import { Density, Mode } from '@cloudscape-design/global-styles';
import { ALWAYS_VISUAL_REFRESH, INCLUDE_ONE_THEME } from '~components/internal/environment';
import SpaceBetween from '~components/space-between';
import AppContext, { Theme } from '../app-context';
export default function ThemeSwitcher() {
    const { mode, urlParams, setUrlParams, setMode } = useContext(AppContext);
    function activateTheme(theme) {
        setUrlParams({
            visualRefresh: theme === 'visualRefresh',
            theme: theme === 'oneTheme' ? Theme.OneTheme : Theme.Default,
        });
        window.location.reload();
    }
    const vrSwitchProps = {
        id: 'visual-refresh-toggle',
        type: 'checkbox',
    };
    if (ALWAYS_VISUAL_REFRESH) {
        vrSwitchProps.checked = true;
        vrSwitchProps.readOnly = true;
    }
    else {
        vrSwitchProps.checked = urlParams.visualRefresh && urlParams.theme !== Theme.OneTheme;
        vrSwitchProps.onChange = event => activateTheme(event.target.checked ? 'visualRefresh' : 'classic');
    }
    return (React.createElement(SpaceBetween, { direction: "horizontal", size: "xs" },
        React.createElement("label", null,
            React.createElement("input", { ...vrSwitchProps }),
            "Visual refresh"),
        INCLUDE_ONE_THEME && (React.createElement("label", null,
            React.createElement("input", { id: "one-theme-toggle", type: "checkbox", checked: urlParams.theme === Theme.OneTheme, onChange: event => activateTheme(event.target.checked ? 'oneTheme' : 'classic') }),
            "One theme")),
        React.createElement("label", null,
            React.createElement("input", { id: "mode-toggle", type: "checkbox", checked: mode === 'dark', onChange: event => setMode(event.target.checked ? Mode.Dark : Mode.Light) }),
            "Dark mode"),
        React.createElement("label", null,
            React.createElement("input", { id: "density-toggle", type: "checkbox", checked: urlParams.density === 'compact', onChange: event => setUrlParams({ density: event.target.checked ? Density.Compact : Density.Comfortable }) }),
            "Compact mode"),
        React.createElement("label", null,
            React.createElement("input", { id: "disabled-motion-toggle", type: "checkbox", checked: urlParams.motionDisabled, onChange: event => setUrlParams({ motionDisabled: event.target.checked }) }),
            "Disable motion")));
}
